import React from "react";
import Dialog from "@material-ui/core/Dialog";
import styles from "./style.module.css";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import GeneratePdf from "./../generatePdf/GeneratePdf";
import DownloadBarcode from "./../barcodePdf/DownloadBarCode.js";
import DownloadOrderExcel from "./../downloadOrderExcel/DownloadOrderExcel";
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";
import Button from "@material-ui/core/Button";
import { Tooltip } from "@material-ui/core";
const DownloadOrder = (props) => {
  console.log("Open Download Order page");
  const orderData = props.order;
  const isLoading = !orderData;
  const showData = orderData;
  const [pdfDialog, setPdfDialog] = React.useState(false);
  const openPdfDialog = () => {
    setPdfDialog(true);
  }
  const closeDialog = () => {
    setPdfDialog(false);
  }
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      scroll={"paper"}
      maxWidth={"lg"}
      fullWidth={true}
    >
      <div className={styles.container}>
        <div className={styles.containerContent}>
          <div className={styles.header}>
            <h1>Download Order</h1>
            <IconButton onClick={props.onClose}>
              <CloseRoundedIcon />
            </IconButton>
          </div>

          {showData == "NO_DATA" && (
            <div className={styles.emptyList}>
              <p>No data</p>
            </div>
          )}

          {showData && showData != "NO_DATA" && (
            <div className={styles.content}>
              <h2></h2>
              <DownloadBarcode order={props.order} />
              <Tooltip title="Download Invoice">
                <Button
                  onClick={openPdfDialog}
                  variant="contained"
                  color="default"
                  className={styles.button}
                  startIcon={<GetAppRoundedIcon />}
                >
                  Download Invoice PDF
                </Button>
                </Tooltip>
              {/* <GeneratePdf order={props.order} /> */}
              <DownloadOrderExcel order={props.order} />
            </div>
          )}
          {isLoading && (
            <div className={styles.loader}>
              <CircularProgress />
            </div>
          )}
          { pdfDialog && ( 
            <Dialog
              open={props.order}
              onClose={closeDialog}
              scroll={"paper"}
              maxWidth={"lg"}
              fullWidth={true}
            >
              <GeneratePdf order={props.order} />
            </Dialog>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default DownloadOrder;
